export default __webpack_public_path__ + "b4518c2b534a5780bb7cc391bec4d53e.png";